import { useMutation, useQueryClient } from '@tanstack/react-query'
import { httpAssignListing } from '@/features/luxe-submissions/http/luxe-submissions.http'
import { VISUAL_VETTING_LISTING_DETAILS_QUERY_KEY } from './use-get-visual-vetting-listing-details'
import { VISUAL_VETTING_LISTINGS_QUERY_KEY } from './use-get-visual-vetting-listings'

export const useAssignListing = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({
			listingIds,
			reviewerId
		}: {
			listingIds: string[]
			reviewerId: number
		}) => httpAssignListing(listingIds, reviewerId),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [VISUAL_VETTING_LISTING_DETAILS_QUERY_KEY]
			})
			queryClient.invalidateQueries({
				queryKey: [VISUAL_VETTING_LISTINGS_QUERY_KEY]
			})
		}
	})
}
